/**
 * @Author: brand
 * @Date: 2019-06-25 17:55
 * @Email: brandhuang@qq.com
 */

import ax from "../../axios";

export function getHistoryDataAPI (params) {
    return ax({
        url: '/wlapi/history/mpHistoryDialogue',
        method: 'POST',
        params,
    })
}

// 短信联系访客
export function contactVisitorByMsg (params) {
    return ax({
        url: '/wlapi/message/sendSms',
        method: 'post',
        params
    })
}
// 其他方式联系访客
export function getReplyHandler (params) {
    return ax({
        url: '/wlapi/ticket/csMessageReply',
        method: 'GET',
        params
    })
}
// 获取所有客服
export function getAllServiceHisAPI (params) {
    return ax({
        url: '/wlapi/history/allCservice',
        method: 'POST',
        params
    })
}

/**
 * 获取聊天历史记录
 * @param {*} params
 */
export function getChatHistory (data) {
    return ax({
        url: '/wlapi/chat/history',
        method: 'POST',
        data
    })
}
/**
 * 获取聊天历史--查看记录
 * @param {*} params
 */
export function queryMsgRecord (params) {
    return ax({
        url: '/wlapi/history/queryMsgRecord',
        method: 'POST',
        params
    })
}
/**
 * 个人信息
 * @param {*} data
 */
export function editVisitorInfo (data) {
    return ax({
        url: '/wlapi/chat/editVisitorInfo',
        method: 'POST',
        data
    })
}
/**
 * 对话导出
 * @param {*} data
 */
export function hisDialogExportInfo (params) {
    return ax({
        url: '/wlapi/history/dialogueOutExcel',
        method: 'POST',
        responseType: 'blob',
        params
    })
}
/**
 * 访客信息导出
 * @param {*} data
 */
export function hisVisitorInfoExportInfo (params) {
    return ax({
        url: '/wlapi/history/historyOutExcel',
        method: 'POST',
        responseType: 'blob',
        params
    })
}

/**
 * 重新加载数据
 * @param params
 */
export function hisFirstPageVisitorInfoInfo (params) {
    return ax({
        url: '/wlapi/history/firstPageRecord',
        method: 'POST',
        params
    })
}
/**
 * 重新加载数据
 * @param params
 */
export function getAllTagListAPI (params) {
    return ax({
        url: '/wlapi/tag/allTagList',
        method: 'POST',
        params
    })
}
/**
 * 历史评价记录
 * @param params
 */
export function getEvaluateRecordListAPI (params) {
    return ax({
        url: '/wlapi/history/visitorEvaluateRecord',
        method: 'POST',
        params
    })
}
/**
 * Author: brand
 * Creation Time: 2019-04-12 13:28
 * Description: 历史轨迹
 */
export function getHistoryTrackAPI(params) {
    return ax({
        url: '/wlapi/track/visitorTrack',
        method: "POST",
        params
    })
}

/**
 * 加入黑名单
 * @param {*} id
 */
export function addBlackListAPI (params) {
  return ax({
    url: '/wlapi/chat/blackAdd',
    method: 'GET',
    params
  })
}
/**
 * 移除黑名单
 * @param {*} id
 */
export function removeBlackListAPI (params) {
  return ax({
    url: '/wlapi/chat/blackRemove',
    method: 'GET',
    params
  })
}

/**
 * Author: wuzhiying
 * createTime: 2020-07-06
 * */ 
/****************************************** 标签 Start ******************************************/
/**
 * 标签列表
 * @param {*} data
 */
export function getTagsList (data) {
  return ax({
    url: '/wlapi/chat/asynTagsList',
    method: 'POST',
    data
  })
}
/**
 * 添加标签
 * @param {*} data
 */
export function addTag (params) {
  return ax({
    url: '/wlapi/chat/addTag',
    method: 'GET',
    params
  })
}
/**
 * 删除标签
 * @param {*} data
 */
export function delTag (params) {
  return ax({
    url: '/wlapi/chat/deleteTag',
    method: 'GET',
    params
  })
}
/****************************************** 标签 End ******************************************/